import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Author } from 'types/article'
import { SocialShare } from '@components/social-share'

import styles from './styles.module.scss'

interface Props {
  publicationDate: string
  authors: Author[]
  title: string
  description: string
}

// Função para formatar data com timezone fixo (Brasília) para evitar erro de hidratação
const formatDateWithTimezone = (dateString: string): string => {
  const date = new Date(dateString)
  // Usa timezone fixo do Brasil para garantir consistência entre servidor e cliente
  const dateOptions: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }

  const timeOptions: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }

  const datePart = new Intl.DateTimeFormat('pt-BR', dateOptions).format(date)
  const timePart = new Intl.DateTimeFormat('pt-BR', timeOptions).format(date)

  return `${datePart}, ${timePart}`
}

export const ArticlePublication: React.FC<Props> = ({
  publicationDate,
  authors,
  title,
  description
}) => {
  const date = formatDateWithTimezone(publicationDate)

  return (
    <div className={styles.articlePublicationContainer}>
      <div className={styles.articleInfos}>
        <div className="w-full flex items-center gap-2">
          <div className="flex">
            {authors?.map((author, index) => (
              <div
                key={index}
                className={`relative h-[72px] w-[72px] overflow-hidden rounded-full ${
                  index > 0 ? '-ml-9' : ''
                }`}
                style={{ zIndex: index + 1 }}
              >
                <Image
                  src={author.avatar}
                  alt={`Avatar de ${author.name}`}
                  fill
                />
              </div>
            ))}
          </div>

          <div className="w-full flex flex-col md:flex-row md:justify-between gap-1">
            {!!authors?.length && (
              <div className="flex flex-col">
                <span className={styles.date}>{date}</span>

                <div className={`${styles.authorContent}`}>
                  <span className="text-black">Por: </span>
                  <Authors authors={authors} />
                </div>
              </div>
            )}
            <SocialShare title={title} description={description} />
          </div>
        </div>
      </div>
    </div>
  )
}

const Authors = ({ authors }) => {
  const connector = (index, length) => {
    if (length === 1 || length - 1 === index) return ''
    if (length - 2 === index) return ' e '
    return ', '
  }

  return (
    <>
      {authors.map((author, index) => (
        <Link key={author.name} href={author.path} className={styles.author}>
          {author.name}
          {connector(index, authors.length)}
        </Link>
      ))}
    </>
  )
}
